<p>test-canvas-page works!</p>
<input [disabled]="computing" type="number" [value]="spaceId" (change)="setSpaceId($event.target.value)">
<div>Target Angle: {{ rad2Deg(targetAngle) }} </div>
<diV>Zoom: {{zoom}}</diV>
<mat-slider [disabled]="zoom == undefined" [value]="zoom" [step]="0.1" [min]="0.5" [max]="5" (change)="changeZoom($event.value)"></mat-slider>
<button (click)="changeCanvasSize()">change</button>
<button (click)="lockAvatar()">lock avatar</button>
<app-test-canvas #canvas [width]="1200" [height]="800"></app-test-canvas>